<template>
    <div id="banner">
        <div class="banner-background"></div>
        <div id="banner-card-container" class="body-block">
            <div id="banner-card">
                <div id="banner-card-title">
                    {{title}}
                </div>
                <div id="banner-card-description">
                    {{description}}
                </div>
            </div>
        </div>
        <div id="banner-sticky"
             v-show="showSticky">
            {{title}}
        </div>
    </div>
</template>

<script>
	export default {
		name: "TheBanner",
		props: {
			title: {
				type: String,
				required: true
			},
			description: {
				type: String,
				required: false
			},
			image: {
				type: String,
				required: true
			}
		},
		created() {
			window.addEventListener("scroll", this.$throttle(this.handleScroll, 75));
		},
		data() {
			return {
				showSticky: false
			}
		},
		methods: {
			handleScroll() {
				let banner = document.getElementById("banner");
				if (banner) {
					this.showSticky = banner.getBoundingClientRect().top <= -window.innerHeight * 0.35 + 48;
				} else {
					this.showSticky = false;
				}
			}
		}
	}
</script>

<style scoped lang="scss">
    #banner {
        position: relative;
        width: 100%;
        height: 35vh;
        border-bottom: $solid;
    }

    .banner-background {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 35vh;
        background-color: $p-accent;
    }

    @media #{$tablet-inv} {
        #banner-sticky {
            display: none;
        }
    }

    #banner-sticky {
        position: fixed;
        top: 0;
        left: 50px;
        height: 48px;
        width: calc(100% - 100px);
        line-height: 48px;
        background-color: $p-bg;
        opacity: 1;
        box-sizing: border-box;
        z-index: 3;
        font-family: $serif;
        font-weight: 700;
        font-size: 18px;
    }

    #banner-card {
        position: relative;
        display: flex;
        top: calc(30vh - 80px);
        height: 100px;
        width: 420px;
        padding: 20px 30px;
        flex-flow: column nowrap;
        justify-content: center;
        box-sizing: border-box;
        text-align: left;
    }

    @media #{$tablet} {
        #banner-card-container {
            margin-left: 0;
            width: 100vw;
        }

        #banner-card {
            width: 100%;
            top: calc(35vh - 100px);
        }
    }

    #banner-card-title {
        font-size: 40px;
        width: 100%;
        font-weight: 700;
        font-family: $serif;
    }

    #banner-card-description {
        line-height: 16px;
        margin-bottom: 4px;
    }
</style>